<template>
  <div class="product-info">
    <div class="bottom-title">
      <div class="bottom-text">填写产品信息</div>
      <el-button v-if="companyHasCode" type="primary" size="small" round icon="el-icon-tickets" @click="onChangeType">
        我的申请
      </el-button>
    </div>
    <div v-loading="submitLoading">
      <el-form :model="dataForm" :rules="dataRules" ref="refForm" label-width="100px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="企业名称" prop="enterpriseName">
              <el-input v-model="dataForm.enterpriseName" disabled placeholder="请输入企业名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="企业码" prop="enterpriseCode">
              <el-input v-model="dataForm.enterpriseCode" disabled placeholder="审核通过后自动获得"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="产品封面" prop="productPicUrl">
              <el-upload
                  v-model="dataForm.productPicUrl"
                  :file-list="fileProductList"
                  action="/service-center/upload/file/single"
                  :headers="headers"
                  :disabled="!companyHasCode"
                  list-type="picture-card"
                  :before-upload="handleBeforeUpload"
                  :on-preview="handleCardPreview"
                  :on-remove="(file, fileList)=>handleBusinessRemove(file, fileList,'fileProductList')"
                  :on-change="(file, fileList)=>handleBusinessChange(file, fileList,'fileProductList')"
                  :on-success="(response,file, fileList)=>handleBusinessSuccess(response,file, fileList,'fileProductList')">
                <i class="el-icon-plus"></i>
                <div class="el-upload__tip" slot="tip">*请上传尺寸为590*375且不超过2M的图片</div>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="产品名称" prop="productName">
              <el-input v-model="dataForm.productName" :disabled="!companyHasCode"
                        placeholder="请输入产品名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="产品数量" prop="productCount">
              <el-input v-model="dataForm.productCount"  :min="1" :disabled="!companyHasCode" type="number"
                        placeholder="请输入产品数量"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="执行标准" prop="productStandard">
              <el-input v-model="dataForm.productStandard" :disabled="!companyHasCode"
                        placeholder="请输入执行标准"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="许可证号" prop="licenseNumber">
              <el-input v-model="dataForm.licenseNumber" :disabled="!companyHasCode"
                        placeholder="请输入许可证号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="规格型号" prop="productModel">
              <el-select v-model="dataForm.productModel" placeholder="请选择规格型号" style="width: 300px;"
                         @change="getModelInfo">
                <el-option v-for="(item, index) in  modelMap" :label="item.modelValue" :key="item.modelKey"
                           :value="item.modelKey">
                </el-option>
              </el-select>
              <!--              <el-input v-model="dataForm.productModel" :disabled="!companyHasCode"-->
              <!--                        placeholder="请输入规格型号"></el-input>-->
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="生产日期" prop="makeDate">
              <el-date-picker
                  v-model="dataForm.makeDate"
                  type="date"
                  :disabled="!companyHasCode"
                  style="width: 100%;"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  placeholder="请选择生产日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="批号" prop="lotNumber">
              <el-input v-model="dataForm.lotNumber" :disabled="!companyHasCode" placeholder="请输入批号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="流量" prop="flowRate">
              <el-input v-model="dataForm.flowRate" :disabled="!companyHasCode" placeholder="请输入流量"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="扬程" prop="headValue">
              <el-input v-model="dataForm.headValue" :disabled="!companyHasCode" placeholder="请输入扬程"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="功率" prop="powerValue">
              <el-input v-model="dataForm.powerValue" :disabled="!companyHasCode" placeholder="请输入功率"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="转速" prop="rotateSpeed">
              <el-input v-model="dataForm.rotateSpeed" :disabled="!companyHasCode" placeholder="请输入转速"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="效率" prop="efficiency">
              <el-input v-model="dataForm.efficiency" :disabled="!companyHasCode" placeholder="请输入效率"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="重量" prop="weightValue">
              <el-input v-model="dataForm.weightValue" :disabled="!companyHasCode" placeholder="请输入重量"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="温升" prop="temperatureRise">
              <el-input v-model="dataForm.temperatureRise" :disabled="!companyHasCode"
                        placeholder="请输入温升"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="频率" prop="frequencyValue">
              <el-input v-model="dataForm.frequencyValue" :disabled="!companyHasCode"
                        placeholder="请输入频率"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="next-btn-box">
        <el-button type="primary" size="small" round :disabled="!companyHasCode" :loading="submitLoading"
                   @click="submitForm">下 一 步
        </el-button>
        <div v-if="!companyHasCode" class="next-time-tips">{{ nextTipsText }}</div>
      </div>
    </div>
    <el-dialog append-to-body :visible.sync="dialogImgVisible">
      <img width="100%" :src="dialogImgUrl" alt="">
    </el-dialog>
    <el-dialog
        class="dialog-code-box"
        append-to-body
        :show-close="false"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        :visible.sync="dialogCodeVisible"
        width="65%">
      <span slot="title">
        <div class="dialog-title">
          <div class="dialog-text">上传企业资质材料
            <span v-if="!companyHasCode" style="margin-left: 20px;" class="next-time-tips">（ {{ nextTipsText }}）</span>
          </div>
        </div>
      </span>
      <div class="dialog-info-box">
        <el-form :model="dialogCodeForm" :rules="dialogCodeRule" ref="refDialogCodeForm" label-width="auto">
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="企业名称">
                <el-input v-model="$store.state.isUsermessage.name" size="small" disabled
                          placeholder="请输入企业名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="商标" prop="enterprisePic">
                <el-upload
                    list-type="picture-card"
                    v-model="dialogCodeForm.enterprisePic"
                    :file-list="fileBusinessList"
                    action="/service-center/upload/file/single"
                    :headers="headers"
                    :disabled="dialogCodeDisabled"
                    :before-upload="handleBeforeUpload"
                    :on-preview="handleCardPreview"
                    :on-remove="(file, fileList)=>handleBusinessRemove(file, fileList,'fileBusinessList')"
                    :on-change="(file, fileList)=>handleBusinessChange(file, fileList,'fileBusinessList')"
                    :on-success="(response,file, fileList)=>handleBusinessSuccess(response,file, fileList,'fileBusinessList')">
                  <i class="el-icon-plus"></i>
                  <div v-if="dialogCodeDisabled" class="el-upload__tip" slot="tip">
                    请上传尺寸为590*375且不超过2M的图片
                  </div>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="质量体系认证证书">
                <el-upload
                    drag
                    :disabled="dialogCodeDisabled"
                    action="/service-center/upload/file/single"
                    :headers="headers"
                    :file-list="dialogCodeForm.qualityAptitude"
                    :on-success="(response,file, fileList)=>handleQualityAptitudeSuccess(response,file, fileList,'qualityAptitude')"
                    :on-remove="(file, fileList)=>handleQualityAptitudeRemove(file, fileList,'qualityAptitude')"
                    :on-preview="handlePreviewDownload">
                  <i class="el-icon-upload"></i>
                  <div v-if="dialogCodeDisabled" class="el-upload__text">审批中的文件不可修改。</div>
                  <div v-else class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="环境安全管理体系认证证书">
                <el-upload
                    drag
                    :disabled="dialogCodeDisabled"
                    action="/service-center/upload/file/single"
                    :headers="headers"
                    :file-list="dialogCodeForm.enAptitude"
                    :on-success="(response,file, fileList)=>handleQualityAptitudeSuccess(response,file, fileList,'enAptitude')"
                    :on-remove="(file, fileList)=>handleQualityAptitudeRemove(file, fileList,'enAptitude')"
                    :on-preview="handlePreviewDownload">
                  <i class="el-icon-upload"></i>
                  <div v-if="dialogCodeDisabled" class="el-upload__text">审批中的文件不可修改。</div>
                  <div v-else class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="职业健康管理体系认证证书">
                <el-upload
                    drag
                    :disabled="dialogCodeDisabled"
                    action="/service-center/upload/file/single"
                    :headers="headers"
                    :file-list="dialogCodeForm.healthAptitude"
                    :on-success="(response,file, fileList)=>handleQualityAptitudeSuccess(response,file, fileList,'healthAptitude')"
                    :on-remove="(file, fileList)=>handleQualityAptitudeRemove(file, fileList,'healthAptitude')"
                    :on-preview="handlePreviewDownload">
                  <i class="el-icon-upload"></i>
                  <div v-if="dialogCodeDisabled" class="el-upload__text">审批中的文件不可修改。</div>
                  <div v-else class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="荣誉证书">
                <el-upload
                    drag
                    :disabled="dialogCodeDisabled"
                    action="/service-center/upload/file/single"
                    :headers="headers"
                    :file-list="dialogCodeForm.honorAptitude"
                    :on-success="(response,file, fileList)=>handleQualityAptitudeSuccess(response,file, fileList,'honorAptitude')"
                    :on-remove="(file, fileList)=>handleQualityAptitudeRemove(file, fileList,'honorAptitude')"
                    :on-preview="handlePreviewDownload">
                  <i class="el-icon-upload"></i>
                  <div v-if="dialogCodeDisabled" class="el-upload__text">审批中的文件不可修改。</div>
                  <div v-else class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="其他材料">
                <el-upload
                    drag
                    :disabled="dialogCodeDisabled"
                    action="/service-center/upload/file/single"
                    :headers="headers"
                    :file-list="dialogCodeForm.aptitudeOther"
                    :on-success="(response,file, fileList)=>handleQualityAptitudeSuccess(response,file, fileList,'aptitudeOther')"
                    :on-remove="(file, fileList)=>handleQualityAptitudeRemove(file, fileList,'aptitudeOther')"
                    :on-preview="handlePreviewDownload">
                  <i class="el-icon-upload"></i>
                  <div v-if="dialogCodeDisabled" class="el-upload__text">审批中的文件不可修改。</div>
                  <div v-else class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div v-if="!companyHasCode" class="next-time-tips">{{ nextTipsText }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--        <el-button size="small" round @click="dialogCodeVisible = false">取 消</el-button>-->
        <el-button v-if="!dialogCodeDisabled" size="small" round type="primary"
                   :loading="dialogCodeLoading" @click="onClickCodeSubmit">
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import {
  getCodeTraceabilityCompany,
  getEnterprise, getModelMap,
  sendCodeTraceabilitySubmit,
  sendEnterprise
} from "../../utils/interface";

export default {
  components: {},
  data() {
    return {
      headers: {
        'Authorization': 'Bearer ' + this.$cookies.get("api_access_token")	//	可以是授权凭证用的参数值
      },
      dataForm: {
        enterpriseUuid: '',
        enterpriseName: this.$store.state.isUsermessage.name,
        enterpriseCode: '',
        productPicUrl: '',
        productName: '',
        productCount: '',
        productModel: '',
        productStandard: '',
        licenseNumber: '',
        makeDate: '',
        lotNumber: '',
        flowRate: '',
        headValue: '',
        rotateSpeed: '',
        powerValue: '',
        efficiency: '',
        weightValue: '',
        temperatureRise: '',
        frequencyValue: '',
        qrCode: '',
      },
      dataRules: {
        enterpriseName: [
          {required: true, message: '请输入企业名称', trigger: 'blur'},
        ],
        enterpriseCode: [
          {required: true, message: '请输入企业码', trigger: 'blur'},
        ],
        productPicUrl: [
          {required: true, message: '请上传产品封面', trigger: 'blur'},
          {required: true, message: '请上传产品封面', trigger: 'change'},
        ],
        productName: [
          {required: true, message: '请输入产品名称', trigger: 'blur'},
        ],
        productCount: [
          {required: true, message: '请输入产品数量', trigger: 'blur'},
          {pattern: /^[1-9]\d*$/, message: '产品数量只能是正整数', trigger: 'blur'},
        ],
        productStandard: [
          {required: true, message: '请输入执行标准', trigger: 'blur'},
        ],
        licenseNumber: [
          {required: true, message: '请输入许可证号', trigger: 'blur'},
        ],
        productModel: [
          {required: true, message: '请输入规格型号', trigger: 'blur'},
        ],
        makeDate: [
          {required: true, message: '请输入生产日期', trigger: 'blur'},
          {required: true, message: '请输入生产日期', trigger: 'change'},
        ],
        lotNumber: [
          {required: true, message: '请输入批号', trigger: 'blur'},
        ],
        flowRate: [
          {required: true, message: '请输入流量', trigger: 'blur'},
        ],
        headValue: [
          {required: true, message: '请输入扬程', trigger: 'blur'},
        ],
        powerValue: [
          {required: true, message: '请输入功率', trigger: 'blur'},
        ],
        rotateSpeed: [
          {required: true, message: '请输入转速', trigger: 'blur'},
        ],
        efficiency: [
          {required: true, message: '请输入效率', trigger: 'blur'},
        ],
        weightValue: [
          {required: true, message: '请输入重量', trigger: 'blur'},
        ],
        temperatureRise: [
          {required: true, message: '请输入温升', trigger: 'blur'},
        ],
        frequencyValue: [
          {required: true, message: '请输入频率', trigger: 'blur'},
        ],
      },
      dialogCodeForm: {
        enterprisePic: '',
        qualityAptitude: [],
        enAptitude: [],
        healthAptitude: [],
        honorAptitude: [],
        aptitudeOther: [],
      },
      dialogCodeRule: {
        enterprisePic: [
          {required: true, message: '请上传商标', trigger: 'blur'},
          {required: true, message: '请上传商标', trigger: 'change'},
        ],
      },
      dialogCodeVisible: false,
      dialogCodeDisabled: false,
      dialogCodeLoading: false,
      productInfo: {},
      queryParams: {
        current: 1,
        pageSize: 5,
        total: 0,
      },
      dialogImgUrl: '',
      dialogImgVisible: false,
      fileBusinessList: [],
      fileProductList: [],
      submitLoading: false,
      companyHasCode: false,//是否有资格赋码
      nextTipsText: '首次请提交企业资格，一般1~2个工作日审核完成！',
      nextStatus: '',
      modelMap: [], // 规格型号下拉框
    };
  },
  created() {

  },
  methods: {
    initData(product) {
      if (product) {
        this.dataForm = product
        this.companyHasCode = true
        this.dialogCodeVisible = false
        this.dialogCodeDisabled = false
        // 回显图片
        this.fileProductList = [{url: product.productPicUrl, name: '产品封面.png',}]
        // 获取规格型号
        getModelMap().then((res) => {
          this.modelMap = res;
        })
      } else {
        this.getCompanyEnterprise()
      }
    },
    submitForm() {
      if (this.fileProductList.length) {
        let file0 = this.fileProductList[0]
        if (file0.response) {
          this.dataForm.productPicUrl = this.fileProductList[0].response.url
        } else {
          this.dataForm.productPicUrl = this.fileProductList[0].url || ''
        }
      } else {
        this.dataForm.productPicUrl = ''
      }
      this.$refs['refForm'].validate((valid) => {
        if (valid) {
          this.submitLoading = true
          sendCodeTraceabilitySubmit(this.dataForm).then((res) => {
            this.submitLoading = false
            this.$emit('onChangeStep', 2, res.data)
          }).catch(err => {
            this.submitLoading = false
          })
        } else {
          this.$message.warning('请完善表单!')
          return false;
        }
      });
    },
    getCompanyEnterprise() {
      getEnterprise().then((res) => {
        if (res.data) {
          this.nextStatus = res.data.status
        }
        if (res.data && res.data.hasOwnProperty('status') && res.data.status === 'REVIEW_PASS') {
          // this.nextTipsText = "恭喜您审核通过，您可以继续使用了"
          this.companyHasCode = true
          this.dialogCodeVisible = false
          this.dataForm.enterpriseCode = res.data.enterpriseCode
          this.dataForm.enterpriseName = res.data.enterpriseName
          // this.$emit('onChangeType', 1) //跳转到申请列表
        } else {
          this.companyHasCode = false
          this.dialogCodeVisible = true
          if (res.data) {
            if (res.data.status === 'INIT') {
              this.dialogCodeDisabled = true
              this.nextTipsText = "您的资质审核中，一般1~2个工作日审核完成！"
            } else if (res.data.status === 'NOT_PASS') {
              this.nextTipsText = "您的资质审核中被驳回，请重新提交，一般1~2个工作日审核完成！"
            } else {
              this.nextTipsText = "资质审核状态错误！"
            }
            this.dialogCodeForm = res.data
            // 回显商标
            this.fileBusinessList = [{url: res.data.enterprisePic, name: '商标.png',}]
          }
        }
      })

      // 获取规格型号
      getModelMap().then((res) => {
        this.modelMap = res;
      })

    },
    onClickCodeSubmit() {
      if (this.fileBusinessList.length) {
        let file0 = this.fileBusinessList[0]
        if (file0.response) {
          this.dialogCodeForm.enterprisePic = this.fileBusinessList[0].response.url
        } else {
          this.dialogCodeForm.enterprisePic = this.fileBusinessList[0].url || ''
        }
      } else {
        this.dialogCodeForm.enterprisePic = ''
      }

      this.$refs.refDialogCodeForm.validate((valid) => {
        if (valid) {
          let isAllEmp = true
          if (this.dialogCodeForm.qualityAptitude.length > 0 || this.dialogCodeForm.enAptitude.length > 0 || this.dialogCodeForm.healthAptitude.length > 0
              || this.dialogCodeForm.honorAptitude.length > 0 || this.dialogCodeForm.aptitudeOther.length > 0) {
            isAllEmp = false
          }
          if (isAllEmp) {
            this.$message.warning('除商标外请至少再提交一项资质！')
            return false
          }
          this.dialogCodeLoading = true
          sendEnterprise(this.dialogCodeForm).then((res) => {
            this.dialogCodeLoading = false
            this.dialogCodeVisible = false
            this.$message({
              type: res.success ? "success" : "warning",
              message: res.message,
            })
            this.getCompanyEnterprise()
          }).catch(err => {
            this.dialogCodeLoading = false
          })
        } else {
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          this.$message.warning('请上传商标！')
        }
      });
    },
    onChangeType() {
      this.$emit('onChangeType', 1)
    },

    getModelInfo(key) {

      let item = this.modelMap.find(item => item.modelKey === key)
      this.dataForm.flowRate = item.flowRate;
      this.dataForm.headValue = item.headValue;
      this.dataForm.rotateSpeed = item.rotateSpeed;
      this.dataForm.powerValue = item.powerValue;
      this.dataForm.efficiency = item.efficiency;
      this.dataForm.weightValue = item.weightValue;
      this.dataForm.temperatureRise = item.temperatureRise;
      this.dataForm.frequencyValue = item.frequencyValue;
    },
    handleBusinessChange(file, fileList, key) {
      this[key] = fileList.slice(-1)
    },
    handleBusinessSuccess(response, file, fileList, key) {
      this[key] = fileList
    },
    handleBusinessRemove(file, fileList, key) {
      this[key] = fileList
    },
    handleCardPreview(file) {
      this.dialogImgUrl = file.url
      this.dialogImgVisible = true
    },
    handleBeforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
        return false;
      }
      // let isSize = true;
      // const reader = new FileReader();
      // reader.readAsDataURL(file)
      // reader.onload = (curFile) => {
      //   const image = new Image()
      //   image.src = curFile.target.result
      //   image.onload = () => {
      //     const {width, height} = image
      //     if (width !== 590 || height !== 375) {
      //       this.$message.error("请上传 590*375 px 的图片！")
      //       isSize = false
      //     }
      //     if (!(isLt2M && isSize)) {
      //       this.fileBusinessList = []
      //     }
      //     return isLt2M && isSize
      //   }
      // }
      const isPNG = /^.png$/.test(file.name.substring(file.name.lastIndexOf('.')));
      const isJPG = /^.jpg$/.test(file.name.substring(file.name.lastIndexOf('.')));

      if (!(isPNG || isJPG)) {
        this.$message.error("上传图片只能是PNG或JPG格式!");
        return false;
      }
      return true
    },
    handlePreviewDownload(file) {
      let a = document.createElement('a')
      a.href = file.url
      a.download = file.name //同源策略限制无法生效
      a.click()
    },
    handleQualityAptitudeSuccess(response, file, fileList, key) {
      this.dialogCodeForm[key] = []
      for (const item of fileList) {
        //新上传的文件
        if (item.response !== undefined) {
          this.dialogCodeForm[key].push({
            url: item.response.url,
            name: item.name,
          })
        } else {//已经上传的文件
          this.dialogCodeForm[key].push({
            url: item.url,
            name: item.name,
          })
        }
      }
    },
    handleQualityAptitudeRemove(file, fileList, key) {
      this.dialogCodeForm[key] = []
      for (const item of fileList) {
        //新上传的文件
        if (item.response !== undefined) {
          this.dialogCodeForm[key].push({
            url: item.response.url,
            name: item.name,
          })
        } else {//已经上传的文件
          this.dialogCodeForm[key].push({
            url: item.url,
            name: item.name,
          })
        }
      }
    },
    resetForm() {
      this.$refs['refForm'].resetFields();
    },
  },
};
</script>

<style scoped lang="less">
.next-time-tips {
  text-align: center;
  color: #d9001b;
  margin: 25px 0;
  font-size: 14px;
  letter-spacing: 0;
  font-weight: normal;
}

.dialog-code-box {

  .dialog-info-box {
    padding: 0 20px;
  }

  /deep/ .el-upload-dragger {
    background-color: #fff;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 450px;
    height: 120px;
    text-align: center;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  /deep/ .el-upload-dragger .el-icon-upload {
    font-size: 67px;
    color: #c0c4cc;
    margin: 40px 0 16px;
    line-height: 0;
  }

  /deep/ .el-dialog__body {
    padding: 0 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
  }
}

.dialog-title {
  border-bottom: 1px solid #cccccc;
  padding-bottom: 20px;
  display: flex;
  justify-content: space-between;
}

.dialog-text {
  color: black;
  font-weight: bold;
  font-size: 24px;
  letter-spacing: 2px;
}

.product-info {
  .next-btn-box {
    width: 100%;
    text-align: center;
    margin-top: 30px;
  }

  .bottom-title {
    border-bottom: 1px solid #cccccc;
    padding-bottom: 20px;
    margin-bottom: 30px;
    display: flex;
    justify-content: space-between;
  }

  .bottom-text {
    color: black;
    font-weight: bold;
    font-size: 24px;
    letter-spacing: 2px;
  }

  /deep/ .el-upload-list--picture-card .el-upload-list__item {
    width: 100px;
    height: 100px;
    line-height: 100px;
  }

  /deep/ .el-upload--picture-card {
    width: 100px;
    height: 100px;
    line-height: 100px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/codeTraceability/ProductInfo.vue